import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DevExtremeModule} from '../devextreme.module';
import {EtsCommonModule} from '../common-services/common.module';
import {ActionBoardPanelComponent} from './action-board-panel.component';
import {ActionBoardCardComponent} from './action-board-card.component';
import {ActionBoardComposerComponent} from './action-board-composer.component';
import {ActionBoardOverlayComponent} from './action-board-overlay.component';
import {ActionBoardFooterBadgeComponent} from './action-board-footer-badge.component';
import {ActionBoardBannerComponent} from './action-board-banner.component';
import {ActionBoardDetailComponent} from './action-board-detail.component';
import {AngularSplitModule} from 'angular-split';
import {DateTimePickerModule} from '../datetime-picker/datetime-picker.module';
import {GenericConfirmationDialogModule} from '../generic-confirmation-dialog/generic-confirmation-dialog.module';

/**
 * CR-20260922-001 — the Action Board. Imported by the workspace module (the panel), the host
 * module (overlay + footer badge) and the APG / Hedging Grid modules (the banner). Declares no
 * providers: ActionBoardService is a root singleton so every consumer sees one board.
 */
@NgModule({
    imports: [
        CommonModule,
        DevExtremeModule,
        EtsCommonModule,
        AngularSplitModule,
        DateTimePickerModule,   // the archive face's completion-date filters
        GenericConfirmationDialogModule   // the composer's "cancel this alert?" confirmation
    ],
    declarations: [
        ActionBoardPanelComponent,
        ActionBoardCardComponent,
        ActionBoardDetailComponent,
        ActionBoardComposerComponent,
        ActionBoardOverlayComponent,
        ActionBoardFooterBadgeComponent,
        ActionBoardBannerComponent
    ],
    exports: [
        ActionBoardPanelComponent,
        ActionBoardOverlayComponent,
        ActionBoardFooterBadgeComponent,
        ActionBoardBannerComponent
    ]
})
export class ActionBoardModule {
}
